import { Box } from '@mui/material';
import type { PropsWithChildren } from 'react';
import { Helmet } from 'react-helmet-async';

interface Props {
  title: string;
}

const Page = ({ children, title }: PropsWithChildren<Props>) => (
  <>
    <Helmet>
      <title>{title}</title>
    </Helmet>
    <Box
      sx={{
        backgroundColor: 'background.default',
        minHeight: '100%',
        padding: '17px 80px 34px 80px',
      }}
    >
      {children}
    </Box>
  </>
);

export default Page;
